import { Chip } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import colorConfigs from '../../configs/colorConfigs';

interface StatusChipProps {
  enabled: boolean;
  trueLabel: string;
  falseLabel: string;
}

export default function StatusChip({ enabled, trueLabel, falseLabel }: StatusChipProps) {
  return <Chip size="small" icon={enabled ? <CheckIcon /> : <CloseIcon />} label={enabled ? trueLabel : falseLabel}
    sx={{
      minWidth: 88,
      height: 28,
      px: 1.25,
      gap: 1,
      justifyContent: 'center',
      fontWeight: 700,
      color: '#fff',
      backgroundColor: enabled ? colorConfigs.buttons.active : '#7a3434',
      '& .MuiChip-icon': { m: 0, color: 'inherit', fontSize: 17 },
      '& .MuiChip-label': { p: 0 },
    }} />;
}
